var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6523 6.89453H12.7363C12.5371 6.89453 12.3476 6.99023 12.2305 7.1543L9.16014 11.4121L7.76952 9.48242C7.65233 9.32031 7.46483 9.22266 7.26366 9.22266H6.34764C6.22069 9.22266 6.14647 9.36719 6.22069 9.4707L8.65428 12.8457C8.71177 12.9259 8.78756 12.9913 8.87536 13.0364C8.96317 13.0815 9.06046 13.1051 9.15917 13.1051C9.25788 13.1051 9.35517 13.0815 9.44297 13.0364C9.53077 12.9913 9.60656 12.9259 9.66405 12.8457L13.7773 7.14258C13.8535 7.03906 13.7793 6.89453 13.6523 6.89453Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.25C5.16797 1.25 1.25 5.16797 1.25 10C1.25 14.832 5.16797 18.75 10 18.75C14.832 18.75 18.75 14.832 18.75 10C18.75 5.16797 14.832 1.25 10 1.25ZM10 17.2656C5.98828 17.2656 2.73438 14.0117 2.73438 10C2.73438 5.98828 5.98828 2.73438 10 2.73438C14.0117 2.73438 17.2656 5.98828 17.2656 10C17.2656 14.0117 14.0117 17.2656 10 17.2656Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/CheckCircle.d93b970b036c6f82c3ba2e8dd6537d98.svg";
export { ForwardRef as ReactComponent };